import "/Users/colingillingham/Code/colin-site-menu/src/components/agent/boot.ts";
import { init } from 'astro/virtual-modules/prefetch.js';init()